import {
  COMPOSITION_GET_DATA_V3,
  type CustomRoleTaxonomySelection,
  TaxonomyType,
} from '@revelio/data-access';

import { getRoleTaxonomyId } from '../../../../../../../shared/selection-lists/utils/roleTaxonomy';
import {
  FilterId,
  isSingleValueFilter,
} from '../../../../../filters/types/filters';
import {
  getEntKindForRoleLevelId,
  ROLE_LEVEL_ID_TO_FILTER_KEY,
} from '../../../../../filters/utils/role-skill-ent-kind';
import { ROLE_FINE_TAXONOMY_TREE_LEVELS } from '../../../../../filters/utils/taxonomy-tree-levels';
import { levelIdsByNumber } from './level-ladder';
import type { IcicleTaxonomy } from './types';

const ROLE_LEVEL_IDS = Object.keys(ROLE_LEVEL_ID_TO_FILTER_KEY);

export const roleIcicleTaxonomy: IcicleTaxonomy = {
  segment: 'role',
  filterId: FilterId.ROLE,
  overlapping: false,
  tiersBelowRoot: 2,
  query: COMPOSITION_GET_DATA_V3,
  breakdownLevelField: 'role_breakdown_level',
  topNField: 'role_top_n',
  tree: {
    kind: 'reference',
    taxonomyType: TaxonomyType.Role,
    levels: ROLE_FINE_TAXONOMY_TREE_LEVELS,
    taxonomyId: ({ activeFilterMap }) => {
      const filter = activeFilterMap.get(FilterId.ROLE_TAXONOMY);
      return getRoleTaxonomyId(
        filter !== undefined &&
          isSingleValueFilter<CustomRoleTaxonomySelection>(filter)
          ? filter.value
          : undefined
      );
    },
  },
  levelIds: (treeLevels) =>
    levelIdsByNumber(
      treeLevels,
      ROLE_FINE_TAXONOMY_TREE_LEVELS,
      ROLE_LEVEL_IDS
    ),
  rankedLevelIds: ROLE_LEVEL_IDS,
  entKind: getEntKindForRoleLevelId,
};
